<template>
  <!-- 蒙版容器：全屏遮罩，点击时调用关闭方法 -->
  <div class="paper-analysis-mask" @click="clossPaperAnalysis">
    <FullTxtArtAnalysisResultWorkBench :full_txt_art_analysis_data="full_txt_art_analysis_data" @clossPaperAnalysis="clossPaperAnalysis" style="max-width: 60vw;"/>
  </div>
</template>

<script>
import FullTxtArtAnalysisResultWorkBench from './FullTxtArtAnalysisResultWorkBench.vue'
export default {
  name: 'FullTxtArtAnalysisTip',
  components: {
    // WorkBench,
    FullTxtArtAnalysisResultWorkBench,
  },
  props: {
    full_txt_art_analysis_data: {
      type: [Object, null],
      required: false,
      default: () => ({})
    },
    // 接收父组件控制的显示状态
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      activeTab: 'goal'
    }
  },
  computed: {
    isDataLoaded() {
      return !!this.full_txt_art_analysis_data && !!this.full_txt_art_analysis_data.id;
    }
  },
  methods: {
    clossPaperAnalysis() {
      this.$emit('clossPaperAnalysis');
    },
    handleEscKeydown(e) {
      if (this.visible && (e.keyCode === 27 || e.key === 'Escape')) {
        this.clossPaperAnalysis();
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKeydown);
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        document.addEventListener('keydown', this.handleEscKeydown);
      } else {
        document.removeEventListener('keydown', this.handleEscKeydown);
      }
    }
  }
}
</script>

<style scoped>
/* 蒙版样式：全屏遮罩 - 使用全局变量适配夜间模式 */
.paper-analysis-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* 蒙版半透明保持不变，遮罩层无需跟随主题 */
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 10px;
  overflow-y: auto;
  box-sizing: border-box;
}


</style>